import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';
import caseStatuses, { CaseStatuses } from '../constants/caseStatuses';

const useCaseStatusColors = () => {
  const theme = useTheme();

  const caseStatusColors: Record<CaseStatuses, string> = useMemo(() => ({
    [caseStatuses.OPEN]: theme.palette.error.main,
    [caseStatuses.IN_PROGRESS]: theme.palette.warning.main,
    [caseStatuses.PENDING]: theme.palette.info.main,
    [caseStatuses.CLOSED]: theme.palette.success.main,
    [caseStatuses.SCHEDULED]: theme.palette.blue.main,
  }), [theme]);

  return caseStatusColors;
};

export default useCaseStatusColors;
